<template>
  <q-item :clickable="clickable" :dense="dense" :tag="tag" @click="$emit('click')">
    <slot />
  </q-item>
</template>

<script>
export default {
  name: 'CItem',
  props: {
    clickable: Boolean,
    dense: Boolean,
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style scoped></style>
